import { Component, Inject, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Response } from '@angular/http';
import { NgForm, FormControl } from '@angular/forms';

import { Acuerdo } from '../acuerdo.model';
import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { ApiService } from '../../core/api.service';
import { Cliente } from '../../cliente/cliente.model';
import { Observable } from 'rxjs/Observable';
import { Producto } from '../../productos/producto.model';
import { ProductoAcuerdo } from '../producto-acuerdo.model';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { EstadoAcuerdo } from '../estado-acuerdo.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { RangoFecha } from '../rango-fecha.model';
import { TdChipsBase } from '../../../../node_modules/@covalent/core/chips/chips.component';
import { EmailAcuerdo } from '../email-acuerdo.model';
import { User } from '../../security/user/user.model';
import { CategoriaAcuerdo } from '../categoria-acuerdo.model';


@Component({
  selector: 'app-acuerdo-add-edit',
  templateUrl: './acuerdo-add-edit.component.html',
  styleUrls: ['./acuerdo-add-edit.component.scss']
})
export class AcuerdoAddEditComponent implements OnInit {
  @ViewChild('acuerdoForm') public acuerdoForm: NgForm;

  private hash: string;
  acuerdo: Acuerdo;

  validationFail = false;
  emailPrincipalFail = false;


  productosPosibles: Observable<Producto[]>;
  selected = new FormControl(0);

  myControl = new FormControl();
  myControl2 = new FormControl();
  clientes: Cliente[];
  filteredOptions: Observable<string[]>;
  filteredOptionsUsuario: Observable<string[]>;
  enabled = true;
  estadoAcuerdo = new EstadoAcuerdo();

  private rangoFecha: RangoFecha;
  private rangoHabil: RangoFecha;
  private disableDateList: String[];
  validDates = [];
  maximoHasta: string;
  numberPattern = /^[0-9]*([.])?(\d{1,2})?$/;

  loadingClients = false;
  loadingUsuarios = false;
  usuarios: User[];

  sinLimite: Boolean = false;

  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private dialogService: DialogService,
    private apiService: ApiService,
    private formValidatorService: FormValidatorService
  ) { }

  async ngOnInit() {
    this.route.data.subscribe(data => {
      this.acuerdo = data.acuerdo;

      if (this.acuerdo.numero === -1) {
        this.limpiarAcuerdo();
      }

      this.acuerdo.cliente = this.acuerdo.cliente ? this.acuerdo.cliente : this.backendService.new(Cliente);
      this.acuerdo.productos = this.acuerdo.productos ? this.acuerdo.productos : [];
      this.enabled = this.acuerdo.estado ? this.acuerdo.estado.id === EstadoAcuerdo.Activo : true;
      if (!this.acuerdo.productos || this.acuerdo.productos.length === 0) {
        this.acuerdo.productos = [];
        this.acuerdo.productos.push(this.backendService.new(ProductoAcuerdo));
      }
      if (!this.acuerdo.categorias || this.acuerdo.categorias.length === 0) {
        this.acuerdo.categorias = [];
        this.acuerdo.categorias.push(this.backendService.new(CategoriaAcuerdo));
      }

      if (this.acuerdo.cliente) {
        this.setListaProductos(this.acuerdo.cliente.id);
      }

      if (this.acuerdo.sinLimiteCompra) {
        this.sinLimite = this.acuerdo.sinLimiteCompra;
      }
    });

    if (!this.acuerdo.emails || this.acuerdo.emails.length === 0) {
      this.acuerdo.emails = [];
      this.acuerdo.emails.push(new EmailAcuerdo());
    }

    this.getClientes();
    this.getUsuarios();

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(null),
      map((opt: string | null) => opt ? this._filter(opt, this.clientes) : this.clientes));

      this.myControl.setValue(this.acuerdo.cliente);
    this.rangoFecha = this.backendService.new(RangoFecha);
    if (this.acuerdo.cliente) {
      await this.getFechasOcupadas(this.acuerdo.cliente.id);
      this.obtenerRangoActual();
    }

    this.filteredOptionsUsuario = this.myControl2.valueChanges.pipe(
      startWith(null),
      map((opt: string | null) => opt ? this._filter(opt, this.usuarios) : this.usuarios));

    this.myControl2.setValue(this.acuerdo.ejecutivoCuenta);

  }
  limpiarAcuerdo() {
    const acuerdo = this.backendService.new(Acuerdo);
    acuerdo.estado = new OperationalParametric();
    acuerdo.estado.id = EstadoAcuerdo.Activo;
    acuerdo.productos = null;
    acuerdo.productos = this.acuerdo.productos;
    this.acuerdo = acuerdo;
  }

  clienteSelected(event: MatAutocompleteSelectedEvent): void {
    this.acuerdo.cliente = event.option.value;
  }

  onBlurCliente(): void {
    if (this.acuerdo.cliente !== this.myControl.value) {
      this.myControl.setErrors({'required' : true});
      this.myControl.setValue('');
      this.acuerdo.cliente = this.backendService.new(Cliente);
    }
    this.getFechasOcupadas(this.acuerdo.cliente.id);
  }

  displayFn(cliente?: Cliente): string | undefined {
    return cliente ? cliente.name : undefined;
  }

  private _filter(value: any, options: any[]): any[] {
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase();
    return options.filter(opt => opt.name.toLowerCase().indexOf(filterValue) === 0);
  }

  async getClientes() {
    this.loadingClients = true;
    this.backendService
        .get(Cliente, Cliente.path + 'all', {}).toPromise()
        .then(opts => {
                this.loadingClients = false;
                this.clientes = Array.from(opts);
                this.filteredOptions = this.myControl.valueChanges
                .pipe(startWith(null),
                 map((opt: string | null) => opt ? this._filter(opt, this.clientes) : this.clientes));

    });
  }

  setListaProductos(idCliente) {
    this.getListaProductos(idCliente);
  }

  async getListaProductos(idCliente) {
    this.productosPosibles = this.backendService.get(Producto, Producto.path + 'all', { });
  }

  agregarProducto() {
    if (!this.validateForm()) {
      this.dialogService.alert('Agregar producto',
      'Antes de agregar un nuevo producto debe completar todos los datos del acuerdo y el producto actual.');
    } else {
      this.acuerdo.productos.push(this.backendService.new(ProductoAcuerdo));
      this.selected.setValue(this.acuerdo.productos.length - 1);
    }
  }

  eliminarProducto() {
    if (this.acuerdo.productos.length === 1) {
      this.dialogService.alert('Eliminar producto',
      'No puede eliminar el único producto del acuerdo.');
    } else {
      this.acuerdo.productos.splice(this.selected.value, 1);
    }
  }

  agregarCategoria() {
    this.acuerdo.categorias.push(this.backendService.new(CategoriaAcuerdo));
  }
  eliminarCategoria(index: number) {
    if (this.acuerdo.categorias[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar la categoría ' + this.acuerdo.categorias[index].description
       + '?')
      .then( res => {
        if (res) {
          this.acuerdo.productos.forEach(p => {
            p.categorias = p.categorias.filter(c => c.description !== this.acuerdo.categorias[index].description);
          });
          this.acuerdo.categorias.splice(index, 1);
          if (this.acuerdo.categorias.length === 0) {
            this.acuerdo.categorias.push(new CategoriaAcuerdo(undefined));
          }
        }
      });
    } else {
      this.acuerdo.categorias.splice(index, 1);
    }
  }
  addFile(event: any, index: number) {
    const file = event.target.files[0];
    if (file.size > 634000) {
      this.snackService.error('La imagen no puede superar los 5mb');
      return;
    }
    this.acuerdo.categorias[index].imagen = file;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.acuerdo.categorias[index].imagen = (reader.result as string).split(',')[1];
      };
    }
  }

  back() {
    this.navigationService.back();
  }

  async confirmSave() {
    if (this.validateForm()) {
      this.dialogService.confirm(this.acuerdo.id ? 'Edición de acuerdo' : 'Alta de acuerdo',
      '¿Está seguro que desea guardar el acuerdo?')
      .then( res => {
        if (res) {
          this.saveAcuerdo(res);
        }
      });
    }
  }

  validateForm() {
    let validationsOK = false;
    // Valida el resto de los controles con sus validadores

    const prodsInvalidos = this.acuerdo.productos.filter(p => p.categorias.length === 0);
    if (!this.formValidatorService.isFormValid(this.acuerdoForm) ||
    this.acuerdo.productos.length === 0 || this.acuerdo.cliente.id === 0 || prodsInvalidos.length > 0) {
        validationsOK = false;
        this.validationFail = true;
        this.snackService.error('Debe completar todos los datos requeridos');
    } else {
      validationsOK = true;
      this.validationFail = false;
    }


    return validationsOK;
  }

  async saveAcuerdo(res) {
    if (res) {

      this.snackService.spinner(true);

        if (this.acuerdo.id) { // Update
          await this.comprobarFechas(false);
          if (this.rangoHabil.habil) {
            try {
              // tslint:disable-next-line:max-line-length
              this.acuerdo.sinLimiteCompra = this.sinLimite;
              this.acuerdo.estado = {description: '', id: this.enabled ? EstadoAcuerdo.Activo : EstadoAcuerdo.Cancelado};
              await this.backendService.update(Acuerdo.path + this.acuerdo.id, this.acuerdo);
              this.snackService.success('Acuerdo editado satisfactoriamente');
              this.router.navigate(['/acuerdos/detalles/' + this.acuerdo.id]);
            } catch (ex) {
              if (ex[0]) {
                this.snackService.error(ex[0].details);
              } else if (ex.errors) {
                this.snackService.error(ex.errors[0].defaultMessage);
              } else {
                this.snackService.error(ex.message);
              }
            } finally {
              this.snackService.spinner(false);
            }
          } else {
            this.snackService.spinner(false);
            this.snackService.error('Fechas ocupadas.');
          }
        } else {
          await this.comprobarFechas(true);
          if (this.rangoHabil.habil) {
            try {
              this.acuerdo.sinLimiteCompra = this.sinLimite;
              const response = await this.backendService.createWithResponse(Acuerdo.path, this.acuerdo);
              const acuerdoResponse = JSON.parse((response as Response).text());
              this.router.navigate(['/acuerdos']);
              this.snackService.success('Acuerdo creado satisfactoriamente');
            } catch (ex) {
              if (ex[0]) {
                this.snackService.error(ex[0].details);
              } else if (ex.errors) {
                this.snackService.error(ex.errors[0].defaultMessage);
              } else {
                this.snackService.error(ex.message);
              }
            } finally {
              this.snackService.spinner(false);
            }
          } else {
            this.snackService.spinner(false);
            this.snackService.error('Fechas ocupadas.');
          }
        }
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  async comprobarFechas(nuevo: boolean) {
    this.rangoFecha.fechaDesde = this.acuerdo.fechaDesde;
    this.rangoFecha.fechaHasta = this.acuerdo.fechaHasta;
    if (nuevo) {
      await this.backendService.getRangoFecha(Acuerdo.path + 'fechas-acuerdos/' + this.acuerdo.cliente.id, this.rangoFecha)
      .then(data => {
        this.rangoHabil = data as RangoFecha;
      });
    } else {
      await this.backendService.getRangoFecha(Acuerdo.path + 'fechas-acuerdos-editar/' + this.acuerdo.cliente.id + '/' + this.acuerdo.id , this.rangoFecha)
      .then(data => {
        this.rangoHabil = data as RangoFecha;
      });
    }
  }

  async getFechasOcupadas(id: number) {
    await this.backendService.getBoolean(Acuerdo.path + 'fechas-ocupadas/' + id).then( data => {
      this.validDates = data;
    });
  }

  async getRango() {
    let i = 0 ;
    while ( i < 90) {
      this.maximoHasta = '';
      const fechaSiguiente = new Date(this.acuerdo.fechaDesde);
      fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
      if (this.validDates[fechaSiguiente.toISOString()]) {
        this.maximoHasta = fechaSiguiente.toISOString();
        return;
      } else {
        i++;
      }
    }
  }

  obtenerRangoActual() {
    let i = 0;
    if (!this.acuerdo.fechaDesde || !this.acuerdo.fechaHasta) {
      return;
    }
    while (i < 90) {
      const fechaSiguiente = new Date(this.acuerdo.fechaDesde);
      const fechaHasta = new Date(this.acuerdo.fechaHasta);
      fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
      this.validDates[fechaSiguiente.toISOString()] = false;
      if (fechaSiguiente < fechaHasta) {
        i ++;
      } else {
        return;
      }
    }
  }

  keyPress(event: any) {
    const pattern = /\d+$/;
    const patternPunto = /\./;
    const inputChar = String.fromCharCode(event.charCode);

    if (pattern.test(inputChar) || patternPunto.test(inputChar)) {
    } else { // invalid character, prevent input
        event.preventDefault();
    }
    let cantidad: string;
    const valor = event.path[0].value;
    if (valor !== null) {
      cantidad = valor.toString().substring(0, event.path[0].selectionStart)
                      + inputChar + valor.toString().substring(event.path[0].selectionStart);
    }
    if (!this.numberPattern.test(cantidad)) {
      event.preventDefault();
    }
  }

  numeroCorrecto(numero: string) {
    const regex = /^\$?\d+(\.\d{1,2})?$/;
    return regex.test(numero);
  }

  onlyNum(event: any) {
    const pegado = event.clipboardData.getData('Text');
      if (this.numeroCorrecto(pegado)) {
        return pegado;
      } else {
        event.preventDefault();
      }
  }

  agregarEmail() {
    this.acuerdo.emails.push(new EmailAcuerdo());
  }

  eliminarEmail(index: number) {
    this.acuerdo.emails.splice(index, 1);
    if (this.acuerdo.emails.length === 0) {
      this.agregarEmail();
    }
  }

  usuarioSelected(event: MatAutocompleteSelectedEvent): void {
    this.acuerdo.ejecutivoCuenta = event.option.value;
  }

  onBlurUsuario(): void {
    if (this.acuerdo.ejecutivoCuenta !== this.myControl2.value) {
      this.myControl2.setErrors({'required' : true});
      this.myControl2.setValue('');
      this.acuerdo.ejecutivoCuenta = this.backendService.new(User);
    }
  }

  displayFnUsuario(usuario?: User): string | undefined {
    return usuario ? (usuario.name + ' ' + usuario.lastname) : undefined;
  }

  async getUsuarios() {
    this.loadingUsuarios = true;
    this.backendService
        .get(User, User.path + 'all', {}).toPromise()
        .then(opts => {
                this.loadingUsuarios = false;
                this.usuarios = Array.from(opts);
                this.filteredOptionsUsuario = this.myControl2.valueChanges
                .pipe(startWith(null),
                 map((opt: string | null) => opt ? this._filter(opt, this.usuarios) : this.usuarios));

    });
  }

  getCategoriasAcuerdo() {
    return this.acuerdo.categorias.filter(c => c.description);
  }

  deleteCompraMaxima() {
    if (!this.acuerdo.sinLimiteCompra) {
      this.acuerdo.compraMaxima = null;
    }
  }

  openWindow(cate: CategoriaAcuerdo) {
    this.dialogService.imageViewer(cate.description, '', 'data:image/jpg;base64,' + cate.imagen);
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-add-edit/acuerdo-add-edit.component.ts